import List from "./List.js";
import Show from "./Show.js";

export default { List, Show };
